/* Preserve Horizon slide/variant markup while deferring hidden image requests. */
(() => {
  const hydrate = slide => {
    if (slide.hasAttribute('hidden') && !slide.hasAttribute('reveal')) return;
    slide.querySelectorAll('img[data-sjd-src]').forEach(image => {
      if (image.dataset.sjdSrcset) image.srcset = image.dataset.sjdSrcset;
      image.src = image.dataset.sjdSrc;
      delete image.dataset.sjdSrc;
      delete image.dataset.sjdSrcset;
    });
  };
  const backgroundObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.style.setProperty('--sjd-latest-banner-image', `url("${entry.target.dataset.sjdLazyBackground}")`);
      backgroundObserver.unobserve(entry.target);
    });
  }, { rootMargin: '300px' }) : null;
  // Use a simple selector fallback for older Android browsers without :has().
  const scanSafe = root => {
    root.querySelectorAll('img[data-sjd-src]').forEach(image => {
      const slide = image.closest('slideshow-slide');
      if (slide) hydrate(slide);
    });
    root.querySelectorAll('[data-sjd-lazy-background]').forEach(element => {
      if (backgroundObserver) backgroundObserver.observe(element);
      else element.style.setProperty('--sjd-latest-banner-image', `url("${element.dataset.sjdLazyBackground}")`);
    });
  };
  scanSafe(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') hydrate(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches('slideshow-slide')) hydrate(node);
          scanSafe(node);
        }
      });
    });
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'reveal', 'aria-hidden'] });

  // A single smaller-CDN retry; never loop or retry third-party trackers.
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement) event.target.parentElement?.querySelector('[data-sjd-image-retry]')?.remove();
  }, true);
  document.addEventListener('error', event => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.closest('.card-gallery, [data-sjd-product-gallery], .sjd-ad, .sjd-b2b')) return;
    const source = image.currentSrc || image.src;
    if (!source || image.hasAttribute('data-sjd-src')) return;
    let url;
    try { url = new URL(source, location.origin); } catch { return; }
    if (url.hostname !== location.hostname && url.hostname !== 'cdn.shopify.com') return;
    if (image.dataset.sjdRetrySource === source || image.dataset.sjdRetryUrl === source) {
      const parent = image.parentElement;
      if (!parent || image.closest('a') || parent.querySelector('[data-sjd-image-retry]')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.sjdImageRetry = '';
      button.textContent = document.documentElement.lang.startsWith('fr') ? 'Réessayer de charger l’image' : 'Retry loading image';
      button.addEventListener('click', () => {
        button.remove();
        delete image.dataset.sjdRetrySource;
        delete image.dataset.sjdRetryUrl;
        // Reload only this failed image, never the page or the entire gallery.
        image.src = url.href;
      });
      parent.append(button);
      return;
    }
    image.dataset.sjdRetrySource = source;
    url.searchParams.set('width', String(Math.min(640, Number(url.searchParams.get('width')) || 640)));
    image.dataset.sjdRetryUrl = url.href;
    image.removeAttribute('srcset');
    image.src = url.href;
  }, true);
})();
